module.exports = __webpack_public_path__ + "img/heit-the-great-logo-inline.c0ef2c73.png";